import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=0a42505e&scoped=true&"
import script from "./Badge.vue?vue&type=script&lang=js&"
export * from "./Badge.vue?vue&type=script&lang=js&"
import style0 from "./Badge.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./Badge.vue?vue&type=style&index=1&id=0a42505e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a42505e",
  null
  
)

export default component.exports